import React from "react";
import injectSheet from "react-jss";
import OppsImg from "Assets/images/e-oops.png";
import Logo from "Components/helpers/Logo";

const styleSheet = () => ({
  container: {
    width: "100%",
    height: "100%",
  },
  innerContainer: {
    width: 600,
    margin: "0 auto",
    marginTop: 75,
  },
  offlineMessageContainer: {
    display: "flex",
  },
  heading: {
    fontSize: 22,
    fontWeight: 400,
  },
  logo: {
    background: `url(${OppsImg}) no-repeat right bottom`,
    width: 194,
    height: 237,
  },
  message: {
    fontSize: 14,
  },
  messageContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    marginLeft: 20,
  },
  anchor: {
    display: "flex",
    justifyContent: "flex-end",
  },
  contactUS: {
    textDecoration: "underline",
  },
});

const OfflineExperience = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.innerContainer}>
      <a className={classes.anchor} href="https://www.youvisit.com/">
        <Logo />
      </a>
      <div className={classes.offlineMessageContainer}>
        <div className={classes.logo} />

        <div className={classes.messageContainer}>
          <h1 className={classes.heading}>Experience Offline!</h1>
          <p className={classes.message}>
            This experience has either been turned off or does not exist.
            <br />
            Please contact our&nbsp;
            <a
              className={classes.contactUS}
              href="mailto:EABDigitalExperience@eab.com?Subject=My%20Experience%20is%20Offline"
            >
              Sales Team
            </a>
            &nbsp;for assistance.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default injectSheet(styleSheet)(OfflineExperience);
